  <template>
    <div style="background:white" class="ve-list-page">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="itemClick('one')">
                <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>生产退料-汇总</div> 
            </div>
            <div  class="oneMenu" @click="itemClick('two')">
                <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>生产退料-明细</div> 
            </div>
        </div>
        <div v-if="actitem=='two'" class="ve-list-page__body">
            <list-item></list-item>
        </div>
        <div v-show="actitem=='one'" style=" background:white;line-height:30px;border-bottom:2px solid #389">
            <div style="padding-top:3px;display:flex;width:1400px; ">
 
                <span style="  font-size:12px;margin-right:10px;margin-left:5px;font-wieght:600">{{ $LANG('0681', '字段查询') }}</span>
                <el-select @change="selChg" v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable  style="width:130px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :disabled="item.key=='adddttm'" :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input v-if="v_bool" :placeholder="input_hold" clearable v-model="txtparam" @keyup.enter.native="inputQry" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px;background:white;border:1px solid #389 " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <template slot ="append">
                        <el-button size="small" slot="append" icon="iconfont icon-gaojichazhao2" @click="inputQry" class="custom-button" ></el-button>
                    </template>
                </el-input> 
                <el-date-picker @change="inputQry" style="width:300px" size="small" value-format="yyyy-MM-dd" v-if="!v_bool"  v-model="txtArr1" type="daterange" :range-separator="$LANG('1657', '至')" :start-placeholder="$LANG('0021', '开始日期')"  :end-placeholder="$LANG('0913', '结束日期')">  </el-date-picker>
                <el-dropdown @command="dropSel"   size="small" style="margin-left:5px;">
                    <el-button type="danger" size="small" style="height:31px">
                        {{ $LANG('0337', '更多') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown"  >
                        <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">{{ $LANG('0172', '导出数据') }}</el-dropdown-item>
                        <el-dropdown-item icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">{{ $LANG('0683', '字段设置') }}</el-dropdown-item>
 
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div v-show="actitem=='one'" style="width:100%" class="ve-list-page__body">
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol" 
                    :table-data="tabData" 
                    :columnHiddenOption="columnHiddenOption"
                    style="margin-top:0px; "
                    :border-around="true"
                    :border-x="true" 
                    :border-y="true" 
                    :fixed-header="true"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="subHeight" 
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"
                   
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                    :footer-data="footerData"
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false,}"
                    id="mat_return"
                    ref="tableRef" >
            </ve-table>
            </div>
            <div style="margin-top:2px" class="ve-list-page__pagination">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
  
        <!-- 提示框 -->
        <el-dialog :show-close="true" v-dialogDrag :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex;">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; overflow-y:auto;max-height:60vh">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <div style="width:100%">
                    <Form :model="formRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in tabCol.filter(item=>item.fhide=='N')" :key="index" >
                            <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                                <el-date-picker size="small" :disabled="saveFlag||item.disabled==='Y'" type="date"  v-if="item.edcss==='date'" v-model="formRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input type="number" size="small" :disabled="saveFlag||item.disabled==='Y'"  v-else-if="item.edcss==='number'" v-model="formRow[item.key]" style="width:100%" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"></el-input>   
                                <el-checkbox v-else-if="item.edcss=='checkbox'"  true-label="Y" false-label="N" v-model="formRow[item.key]"></el-checkbox>
                                <el-input size="small" :disabled="saveFlag"  v-else-if="item.edcss=='button'" readonly   v-model="formRow[item.key]" style="width:100%"> 
                                    <template slot="suffix" > <el-link :disabled="saveFlag"  @click="inputBtn( '',item.key,'')" :underline="false" style="margin-top:3px" ><i class="iconfont icon-icon-choose" style="color:red" ></i></el-link></template>
                                </el-input>  
                                <el-select size="small" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="formRow[item.key]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                </el-select>
                                <el-input size="small" :placeholder="item.holder" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="formRow[item.key]" ></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </div>
                        
                <div class="one-div">
                    <span class="oneRow"> {{ $LANG('0990', '退货明细') }}</span>
                </div> 
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    :height="dtlHeight" 
                    :row-key="getRowKey"
                    :row-class-name="tabRowClass"
                    style="margin-top:-8px"
                    @row-click="rowClick"
                    cell-class-name="clearPadding"
                    show-summary
                    :summary-method="getSummary"
                    :cell-style="{padding:'2px',color:'black','font-size':'12px'}"
                    class="custom-table-border"
                    ref="refdtl"
                    highlight-current-row >          
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="55"></el-table-column>
                    <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index" 
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                        :min-width="item.width">
                        <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
                        <template slot-scope="scope">  
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >               
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+' ].includes(e.key))?false:e.returnValue"  v-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <el-checkbox v-else-if="item.edcss=='checkbox'" :disabled="item.key!=='ISORD'" true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <el-input size="mini" v-else-if="item.edcss=='button'" readonly @focus="vatBtn(scope.row,item.key,scope.$index)"  v-model="scope.row[item.key]" style="width:100%;border:1px solid #778898"> </el-input>  
                                <el-input   v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                            </span>
                        </template> 
                    </el-table-column>   
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="70">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-fuzhi" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag" @click="cpRec(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:6px ">复制</span></el-link> -->
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag" @click="dtlDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px; ">{{ $LANG('0131', '删除') }}</span></el-link>
                        </template>
                    </el-table-column>    
                </el-table>                
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="saveFlag"  type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
 
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate,getDate2} from '../../api/Select' 
 
import repWin from '../datamgt/repWin.vue' 
import listItem from './stk_prdrtn_two.vue'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
export default {
    name:'prd_return',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '401219',
            fieldIdseq: '401219',
            fieldLstseq: '1',
            mainColumnKey: 'tabCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
            lockedFieldKeys: ['ordno'],
        })
    ],
    data () {
        return {
 
            v_row:{},
            v_table:'',
            v_tabRow:{},
            t_cond:'',
            chkIndex: 0,
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            v_chk1:'N',
 
            txtArr1:[],
            ruleValidate:{},
            v_bool:true,
 
            v_commit :true,
            promptWin:false,
            formRow:{},
            comboArr:[],
 
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容...'),
            v_index:0,
            selparam:'IDNO',
            txtparam:'',
            mainRow:{},
 
            goPage:'',
            v_chk3:'N',
            tabData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            appBool:false, //作废权限
            delBool:false,
            v_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            v_clntno:'',
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            pageSize: 100,  
            pageList: [100,500,1000],
            loadWin:false,
            dataCount:0,
            vueCol:[],
            v_dtlRow:{},
            dtlCol:[],
            tabCol:[],
            operArr:[],
            prcCol:[],
            prcData:[],
            dtlChecks:[] ,
            oper:'like',
            v_key:'',
  
            posChecks:[],
            initCol:[],
            delDtlArr:[],
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            repWin:false,
            repUrl:'',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_random:0,
            notNull:[],
            pageIndex:1,
            loadingInstance: null,
            actitem:'one',
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,                
            }, 
            startRowIndex: 0,
            footerData:[], 
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1"      
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            v_sort:'asc',
        }
    },
    components: {
 
      repWin,
 
      listItem,
      VeColumnConfigDialog,
 
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 190) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 325) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
    },
    mounted () {
 
        this.comSelect()
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        }) 
         //用户权限表
        getBaseData('xuper_auth/getBaseData','userno',this.v_username,'frmidseq','401219','v_sys_user_priv','').then(res=>{           
            let row =res.result[0]
            if (row.ISADD==='N'){ //新增
                this.addBool=true
            }if (row.ISUPD==='N'){ //修改
                this.editBool=true
            }if (row.ISDEL==='N'){ //删除
                this.delBool=true
            }if (row.ISCFM==='N'){ //审核
                this.cfmBool=true
            }if (row.ISEXP==='N'){ //作废
                this.appBool=true
            }
 
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','401219','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空'),trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        //报表清单
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','401219','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {
        if (this.v_username){
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#mat_return"),
                name: "wave",
            })
            this.getTabCol() //表列集合
            this.inputQry() //询价单主数据   
 
            this.showkey()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        itemClick(val){
            this.actitem =val     
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]  
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]     
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },

        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: this.v_url+'',
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'401219',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData(this.v_url,'parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.formRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) { 
                let v_flag=false  ,v_title=''  
                this.dtlData.forEach(item=>{
                    this.dtlCol.filter(item2=>item2.notnull=='Y').some(it=>{
                        if (!item[it['key']]){
                            v_flag =true
                            v_title=it['title']
                        }
                    })
                })
                const v_arr_ =this.dtlData.filter(item=>Number(item['ACTQTY'])>Number(item['POQTY']))
                if (v_flag ){
                    this.promptWin =true
                    this.prompt =this.$LANG('1267', '明细资料中的')+' "'+v_title +'" '+this.$LANG('2051', '不能为空')
                }else if (v_arr_.length>0 ){
                    this.promptWin =true
                    this.prompt ='明细资料中的 退料数 不能大于领料数'
                }else{
                    
                    this.v_commit =false
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.formRow,{CORPID:this.v_corpid })), p_table:'IC_STK',frmid:'401219'},
                    }).then(res=>{      
                        if(res.code ==='200')  {  
                            let idseq_ =res.idseq
                            //1、明细保存：批量保存   
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'IC_STKdtl',p_idseq:idseq_ , p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promtWin=true
                                    this.prompt=res.result
                                    this.v_commit =true
                                }else{                        
                                    //明细删除
                                    for (let k=0;k<this.delDtlArr.length;k++) {
                                        this.$axios({   
                                            method: 'post',
                                            url:'xuper_auth/delTabRec',
                                            data: {p_key:'idseq',p_value:idseq_,p_key2:'lstseq',p_value2:this.delDtlArr[k].LSTSEQ, p_table:'IC_STKdtl', p_action:'D' },
                                        })
                                    } 
                                    this.addWin =false   
                                    this.v_commit =true
                                    this.inputQry()
                                }
                            })
                        }else{
                            this.promptWin=true
                            this.prompt =res.result
                            this.v_commit =true
                        }        
                    }) 
                }
            }
        },
 
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                this.saveFlag=false
            }
            this.formRow =JSON.parse(JSON.stringify(row ))
            this.delDtlArr=[]
            //明细
            this.getDtlList(row.IDSEQ)
            this.addWin=true   
            this.v_commit =true   
        },
        // 明细 
        getDtlList(idseq ){
            this.dtlData=[]
            getTabColOrData(this.v_url,'V_IC_STKDTL_PRDRTN','idseq',idseq,'','','','',' ORDER BY matNO' ).then((res) => { 
                this.dtlData =res.result 
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                })
            })            
        },
        dtlDel(row,index){
            this.dtlData.splice(index,1)
            this.delDtlArr.push(JSON.parse(JSON.stringify(row)))
        },
        //状态变更
        stfgRec(row,val,index,v_comm){
            let v_cond ='' ,v_chkdttm='',v_chkuser='' , vm=this
            if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',cHKuser=\''+v_chkuser+'\',cHKdttm=\''+v_chkdttm+'\''
            }else{
                v_chkuser='',v_chkdttm=''
                v_cond =' set stfg=\''+val+'\',cHKuser=\''+v_chkuser+'\',cHKdttm=\''+v_chkdttm+'\''
            }
            this.$axios({
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'IC_STKdtl',p_cond: ' and actqty is null'},
            }).then(res=>{ 
                if (res.result.length>0 && val=='Y'){
                    this.prompt ='明细记录的退料数量不能为空'
                    this.promptWin =true 
                    return
                }
                this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    type:'info',
                }).then(()=>{
                    
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'IC_STK',p_cond: v_cond},
                    }).then(res=>{      
                        if(res.code =='200')  {  
                            this.inputQry()
                        }else{
                            const errorMsg =res.result
                            const startIndex = errorMsg.indexOf("ORA-20001:") 
                            const endIndex = errorMsg.indexOf("请核查") +3
                            const extractedValue = errorMsg.substring(startIndex, endIndex).trim()
                            this.prompt =extractedValue
                            this.promptWin =true 
                        }    
                    })
                }).catch(()=>{})   
            })
        },

        rowClick(row){
 
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =this.dtlData.map(item=>Number(item[column.property]));
                if( column.property==='ACTQTY'||column.property==='POQTY' ){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        inputBtn( row, key,index){   
            this.v_key =key  
            this.v_random =Math.random()  
 
        },
        vatBtn( row, key,index){   
 
        },
        //split-button 下拉选项
        dropSel(val){
            if (val =='expdata'){ //导出数据
                this.loadWin=true
                //导出
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'401219',p_lstseq:'1',p_json:JSON.stringify(this.allList),p_action:'生产退料'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = '生产退料_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)
                    this.loadWin=false
                })
 
            } else if (val =='fldset'){  //字段设置显示--隐藏
                this.openFieldSettingsDialog().catch(error => {
                    this.promptWin =true
                    this.prompt =error.message || this.$LANG('1225', '字段显示设置')
                })
            }
        },
 
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        selChg(val){
            this.tabCol.some(it=>{
                if (it['key']== val){
                    if (it['edcss']=='date'){
                        this.v_bool =false
                    }else{
                        this.v_bool =true
                    }
                }
            })
            this.txtArr1=[]
            this.txtparam1=''
        },
 
        //字段查询
        inputQry(){
            let cond_='' ,v_edcss='',v_edcss2=''
            if (this.selparam){ //列1
                this.tabCol.some(item=>{
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (v_edcss =='date'){
                    if (this.txtArr1 )
                    cond_=cond_+' and '+this.selparam+' between \'' + this.txtArr1[0]+'\' and \''+ this.txtArr1[1]+'\''
                }else {
                    if (this.oper==='like'){
                        cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                    }else{
                        if (this.txtparam){
                            if (v_edcss=='number'){
                                cond_=cond_+' and  '+this.selparam  +this.oper+ this.txtparam
                            }else {
                                cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                            }
                        }
                    }
                }
            }
 
            let v_cond ='' , v_oper='=' 
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
 
                    if (v_edcss =='number' ){
                        v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                    }else if ( v_edcss=='date'){
                        if (v_oper =='like'){
                            v_cond =v_cond +' and '+item+ ' like \''+this.v_row[item] +'%\''
                        }else {
                            v_cond =v_cond +' and '+item+ v_oper +'\''+this.v_row[item] +'\''
                        }
                    }else{
                        
                        v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        
                    }                   
                }
            })
            this.getTabList(cond_+v_cond)
        },
 
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.getTabList('')
        } ,
 
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
 
 
        getRowKey(row){
            return row.index
        },
   
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            if (row['ROWSTFG']=='N') {  //未开始
                return 'black-row'
            }else if (row['ROWSTFG']=='Y') {  //进行中
                return 'red-row'
            }
        },
 
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex =index
            this.tabData = this.allList.slice(_start,_end)
            this.getFootSum()
        },
        //初始化查询页条数
        initPage(){
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.pageSize){
                this.tabData = this.allList          
            }else{
                this.tabData =this.allList.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
            }
            this.getFootSum()
        },
        getFootSum(){
            //累计数组中 接办数量的和
            let v_ttlqty =this.tabData.reduce((prev,cur)=>{
                let v_qty =cur.CUTQTY ||0    
                return Number(prev) + Number(v_qty) 
            },0)
 
            // footer data
            this.footerData =[
                {
                    rowKey: 0,
                    index: this.$LANG('0280', '合计'),
                    CUTQTY: v_ttlqty?v_ttlqty.toLocaleString():'',
 
                },
            ]
        } , 
        //查询界面
        getTabList(cond){    
            this.loadingInstance.show() 
            getTabColOrData(this.v_url,'V_IC_STK_PRDRTN','IDTY','PRDRTN','corpid',this.v_corpid,'','',cond +' order by '+this.selparam+' desc').then((res) => { 
                this.allList =res.result 
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.loadingInstance.close() 
                }) 
                this.initPage() 
            })
      
        },
 
        //获取表列头字段 
        getTabCol(){
            var vm=this
            this.vueCol =[]
            this.tabCol =[]
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','401219','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                this.initCol =res.result
                return this.loadInitialFieldSettings().then(() => res)
            }).then(() => {
                this.vueCol =[]
                this.tabCol =[]
                const mainFields =this.sortFieldRows(this.initCol)
                for (let k=0; k<mainFields.length; k++){
                    const rowField =mainFields[k]
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                        key: rowField.key,
                        align: rowField.align,
                        width: rowField.width,
                        thide:rowField.THIDE,
                        fhide:rowField.FHIDE,
                        edcss:rowField.EDCSS,
                        disabled:rowField.DISABLED,
                        dotnum:rowField.DOTNUM,
                        holder:rowField.HOLDER,
                        sortable:rowField.SORTABLE,
                        fix:rowField.ISFIX,
                    })
                    let itcol =rowField
                    if (itcol['THIDE']=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            type:itcol.EDCSS=='checkbox'?'check':itcol.EDCSS,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='date'||itcol.EDCSS =='time') {
                                    return (                              
                                        <div >                   
                                            <div style="margin-top:3px;display:flex;white-space: nowrap;  " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700">{column.title}</el-link>                                            
                                            </div> 
                                            <div style="display:flex;height:28px;"> 
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_row[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                    <option    value="="  >=</option>
                                                    <option    value=">"  >&gt;</option>
                                                    <option    value="<"  >&lt;</option>
                                                    <option    value="!="  >!=</option>
                                                </select>                                             
                                                <el-date-picker v-model={this.v_row[column.key]} value-format="yyyy-MM-dd" size="mini"  placeholder="yyyy-mm-dd" style="width:100%" on-change={()=>this.inputQry() }  ></el-date-picker>                                                           
                                            </div>
                                        </div>                                   
                                    )
                                } else{
                                    if (itcol.EDCSS =='number') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_row[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                        <option    value="="  >=</option>
                                                        <option    value=">"  >&gt;</option>
                                                        <option    value="<"  >&lt;</option>
                                                        <option    value="!="  >!=</option>
                                                    </select>                                                 
                                                    <el-input  placeholder={this.$LANG('1663', '请输入')}  disabled={itcol.EDCSS=='image'}  v-model={this.v_row[column.key]}   on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                                </div>
                                            </div>                                   
                                        )
                                    }else{
                                        if (itcol.EDCSS=='checkbox'){
                                            return (                              
                                                <div >
                                                    <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                        <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                    </div>  
                                                    <div style="display:flex">
                                                        <el-select size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]}   on-change={()=>{this.inputQry()}}>
                                                            <el-option  value="Y" label={this.$LANG('2047', '是')} ></el-option>
                                                            <el-option  value="N"  label={this.$LANG('2044', '否')} ></el-option>
                                                        </el-select>                                                          
                                                    </div>
                                                </div>                                   
                                            )    
                                        }else {
                                            return (                              
                                                <div >
                                                    <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                        <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                    </div>  
                                                    <div style="display:flex">
                                                        <el-input  placeholder={this.$LANG('1663', '请输入')}  disabled={itcol.EDCSS=='image'}  v-model={this.v_row[column.key]}   on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                                    </div>
                                                </div>                                   
                                            )
                                        }
                                    }
                                }
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.EDCSS=='image' ){
                                    return ( 
                                        <el-image fit="scale-down"  style="width:100%;height:30px; " src={rowVal} preview-src-list={[rowVal]}>
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else if (itcol.EDCSS=='checkbox' ) {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else if (column.key=='IDNO') { //procShow(scope.row)
                                        return (
                                            <el-link   on-click={()=>{this.repBtn(row)}}  underline={false} ><span style="font-size:13px;border-bottom:1px solid #409eff;font-weight:700">{row[itcol['key']]}</span></el-link> 
                                        )
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width: 205,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row['STFG'] =='Y')   {                   
                            return ( 
                                <div>
  
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>                                    
                                    <el-link disabled={this.cfmBool} on-click={()=>{this.stfgRec(row,'N',rowIndex,this.$LANG('0137', '弃审'))}}  underline={false} ><span style="font-size:12px;margin-right:4px;">{this.$LANG('0137', '弃审')}</span></el-link>
                                </div>                                
                            )
                        }else{
                            return ( 
                                <div>
 
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>                                    
                                    <el-link disabled={this.editBool} on-click={()=>{this.editRec(row,'N',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:4px;">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>                                    
                                    <el-link disabled={this.cfmBool} on-click={()=>{this.stfgRec(row,'Y',rowIndex,this.$LANG('0134', '审核') )}}  underline={false} ><span style="font-size:12px;margin-right:4px;">{this.$LANG('0134', '审核')}</span></el-link>
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>                                    
                                    <el-link disabled={this.delBool} on-click={()=>{this.stfgRec(row,'X',rowIndex,this.$LANG('0257', '作废') )}}  underline={false} ><span style="font-size:12px;margin-right:4px;">{this.$LANG('0257', '作废')}</span></el-link>
                                </div>                                
                            )
                        }
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                this.applyFieldSettingRows()
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','401219','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        holder:res.result[k].HOLDER,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
 
        },
    }
}
</script>
<style scoped lang="less">
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .oneButton{
        display:flex;
        background: aliceblue;
        margin-top:1px ;
        margin-bottom:1px;
    }
    .oneButton:hover{
        background:rgb(224, 245, 252);
        cursor: pointer;
    }
    .custom-append {
        width: 40px; /* 设置你想要的宽度 */
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        background-color: #fff;
        border-left: 1px solid #3d6fe2;
        padding: 0 5px;
    }
    .item-width  {
        height:20px;
        width: 32%;
    }
    .item-one {
        width: 97%;
        height:88px;
    }
    .custom-button {
      background: rgb(107, 104, 104);
      font-weight:600;
      font-size:14px;
      color:#cc0000 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .custom-button:hover {
     // background: rgb(107, 104, 104);//rgb(248, 230, 230) !important;
      font-weight:600;
      font-size:14px;
      color:#389 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
 
    .ve-table-footer-tr{
        height:30px !important;
    }
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
    .table-head-cell-red {
        font-size: 12px !important;
        color: #ec0f34 !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
    }
    .el-table .red-row  {
        color: red;
 
    }.el-table .black-row  {
        color: black;
    }
    .el-table__body tr.current-row > td {
        background-color: #F1e1ff !important;
    } 
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-range-separator {
        width: 20px !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple; 
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .default-row {
        color:black;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-table .green-row  {
        color: green;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
